// import ActionLine from "@/base/action-line";
// import { actionLineWithoutImport, actionLineWithImport } from '@/common/js/desc.js'

export default {
  components: {
    // ActionLine,
  },
  methods: {
    handleActionLine(handler) {
      this[handler] && this[handler]();
    },
  }
}


// WEBPACK FOOTER //
// ./src/common/mixins/action-line/index.js